<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted } from "vue";
import { getDisplay, getKZValueDisplay } from "@/DataHelper";
import { Globals } from "@/Globals";
import Constants from "@/Constants";
import { showSnackbar } from "@/UIHelper";
import CalcButton from "@/components/CalcButton.vue";
import { globalsBezeichnung } from "@/local";
const emit = defineEmits<{
  back: [];
  calculated: [data?: any];
  calculating: [data?: any];
}>();
interface Props {
  modellDefault?: string;
  icon?: string;
  varDatum?: string;
  query?: string;
  size?: string;
  text?: string;
  carousel?: ListItems[];
  disabled?: boolean;
  aic?: number;
  calculated?: any;
  noCarousel?: boolean;
  checkTimeZone?: boolean;
  checkGeoLocation?: boolean;
  modellAic?: number;
 varUebergabe?: VarUebergabe[];
};
const props = defineProps<Props>();
const currentSlide = ref(0);
let initalized = ref<boolean>(false);

let showCarousel = ref<boolean>(true);
let showLoading = ref<boolean>(false);

let zeitbereich!: APIZeitbereich | null;
let siteData: any;
let carousel = ref<boolean>(false);
let header: QueryHeader = { bezeichnung: " -- " };
let queryAIC!: number;
let rowdata: QueryDataRow[] = [];
let columns: DataColumn[] = [];
let items: ListItems[] = [];
onMounted(() => {
  showLoading.value = true;
  if (props.modellAic) {
    queryAIC = props.modellAic;
  }
  console.log("Button Carousel list start...");
  try {
    if (props.noCarousel) {
      showCarousel.value = false;
      carousel.value = false;
    }
    if (Constants.isMobile) {
      showCarousel.value = false;
    }
    if (props.carousel) {
      // übergibt gleich Modelle oder Buttons mit Submasken... muss noch hergerichtet werden!
    }
    if (props.query == null || props.query === "") {
      showSnackbar(
        globalsBezeichnung(
          Globals.Begriff,
          "Web_keine_Abfrage",
          "keine Abfrage gefunden"
        )
      );
      header = { bezeichnung: ";(" };
      return;
    }
    if (siteData) {
      if (siteData.zeitbereich) {
        zeitbereich = siteData.zeitbereich;
      }
    }
    const vecStamm: any[] = [];
    AUApi.Current.getQuery(
      // Query
      props.query,
      // Done function
      (data: any) => dataLoaded(data),
      queryAIC,
      zeitbereich,
      0,
      false,
      false,
      "",
      0,
      vecStamm
    );
  } catch (e: any) {
    console.error("mounterror: " + e, e?.stack);
  }
});
function dataLoaded(data: any) {
  console.log("list data loaded");
  // Fehlerbehandlung
  if (data.data.error !== undefined) {
    AUApi.Current.onfail(data.data.error);
    console.log(data.data.error);
    alert("ACHTUNG: " + data.data.error);
    emit("back");
    return;
  }

  header = data.data.header.bezeichnung;
  columns = data.data.columns;
  rowdata = data.data.data;
  if (rowdata.length > 0) {
    carousel.value = true;
  }

  // count = data.data.data.header.zeilen;

  for (let i = 0; i < rowdata.length; i++) {
    const row = rowdata[i];
    const header = getKZValueDisplay(row, "header", columns);
    const title = getKZValueDisplay(row, "titel", columns);
    const subtitel = getKZValueDisplay(row, "subtitel", columns);

    const text = getKZValueDisplay(row, "text", columns);
    // const icon = getKZValueDisplay(row, "icon", columns);
    const color = getKZValueDisplay(row, "color", columns);
    items.push({
      header,
      title,
      subtitel,
      text,
      divider: true,
      inset: true,
      icon: props.icon,
      color,
      modell: props.modellDefault,
    });
  }
  showLoading.value = false;
  initalized.value = true;
}
function cycleSlides() {
  currentSlide.value = (currentSlide.value + 1) % items.length;
}
function onCalculating(args: any) {
  emit("calculating", args); // einmal weiterreichen nach oben bitte..
}

function onCalculated(args: any) {
  emit("calculated", args); // einmal weiterreichen nach oben bitte..
}
</script>
<template>
  <v-carousel
    width="auto"
    height="60"
    :show-arrows="false"
    hide-delimiters
    hide-delimiter-background
    progress="#db5959"
    v-model="currentSlide"
    v-if="initalized && carousel"
  >
    <v-carousel-item v-for="(item, i) in items" :key="i">
      <CalcButton
        :text="item.title"
        :modell="item.modell"
        :color="item.color"
        :icon="item.icon"
        @calculating="onCalculating"
        @calculated="onCalculated"
        :disabled="disabled"
        :varUebergabe="props.varUebergabe"
        varName2="WebBuchungsart"
        :varZeitart="item.subtitel"
        :modellAic="queryAIC"
      ></CalcButton>
      <div class="navigation-arrows" v-if="items.length > 1">
        <v-btn
          size="small"
          icon="mdi-chevron-right"
          color="error"
          class="my-1"
          @click="cycleSlides"
        >
        </v-btn>
      </div>
    </v-carousel-item>
  </v-carousel>
</template>

<style scoped>
.navigation-arrows {
  position: absolute;
  top: 0;
  right: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 1;
}
.fill-height {
  position: relative;
}
</style>
